import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from '../../../../constant/routeConstant';
import {getDepotList, insert} from '../../../../service/admin/data-group/dataGroupServices';
import {useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';

const useAddDataGroup = () => {
    const [tab, setTab] = useState(1);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {token, client_id, resource_user_id} = useSelector((state) => state.auth);

    const [dataGroupName, setDataGroupName] = useState('')
    const [description, setDescription] = useState('')
    const [depotList, setDepotList] = useState([])
    const [flag, setFlag] = useState()

    const [dataGroupNameError, setDataGroupNameError] = useState(false)
    const [descriptionError, setDescriptionError] = useState(false)
    const [depotListError, setDepotListError] = useState(false)

    const [successModalOpen, setSuccessModalOpen] = useState(false)

    const [failedModalOpen, setFailedModalOpen] = useState(false);
    const [failedMessages, setFailedMessages] = useState("");
    const [change, setChange] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const onChange = (namespace, event) => {
        let value = event
        setChange(true);
        switch (namespace) {
            case 'dataGroupName':
                if (value !== '') {
                    setDataGroupName(value)
                    setDataGroupNameError(false)
                } else {
                    setDataGroupNameError(true)
                }
                break;

            case 'description':
                if (value !== '') {
                    setDescription(value)
                    setDescriptionError(false)
                } else {
                    setDescriptionError(true)
                }
                break;

            default:
                break;
        }
    }

    const handleSave = async () => {
        let body = {}
        if (flag === undefined || flag === 1) {
            setDepotListError(true)
        } else {
            if (flag === 2) {
                body = {
                    data_group_id: dataGroupName,
                    description: description,
                    scope_depot_id_list: [-1]
                }
            } else {
                body = {
                    data_group_id: dataGroupName,
                    description: description,
                    scope_depot_id_list: depotList
                }
            }
        }

        if (dataGroupName !== '' && description !== '' && depotList !== []) {
            try {
                let res = await insert(token, null, body, '', dispatch)
                if (res.status) {
                    setSuccessModalOpen(true)
                } else {
                    setFailedModalOpen(true)
                    setFailedMessages(res.message)
                }
            } catch (error) {
                console.log(error)
            }
        }

    }

    const handleNext = () => {
        if (dataGroupName !== '' && description !== '') {
            setTab(2)
        }
        if (dataGroupName === '') {
            setDataGroupNameError(true)
        }
        if (description === '') {
            setDescriptionError(true)
        }
    }

    const handleBack = () => {
        setTab(1);
    }

    const backToList = () => {
        navigate(ROUTES.DATA_GROUP.LIST)
    }

    const _onOk = () => {
        setSuccessModalOpen(false);
        backToList();
    }

    return {
        tab,
        handleNext,
        handleBack,
        backToList,
        dataGroupName,
        setDataGroupName,
        description,
        setDescription,
        depotList,
        setDepotList,
        flag,
        setFlag,
        dataGroupNameError,
        setDataGroupNameError,
        descriptionError,
        setDescriptionError,
        depotListError,
        setDepotListError,
        onChange,
        handleSave,
        successModalOpen,
        setSuccessModalOpen,
        navigate,
        _onOk,
        failedMessages,
        failedModalOpen,
        setFailedModalOpen,
        change,
        showConfirm,
        setShowConfirm
    }
}

export default useAddDataGroup;